var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.grid
    ? _c(
        "div",
        { staticClass: "purchase" },
        [
          _vm._l(_vm.files, function (img, i) {
            return _c(
              "div",
              {
                key: i,
                staticClass: "box",
                class: { selected: _vm.isSelected(img) },
                on: {
                  mousedown: function ($event) {
                    return _vm.onMouseDown($event)
                  },
                  click: function ($event) {
                    return _vm.onClick(img, $event)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "toolbar" },
                  [
                    _c("w-checkbox", {
                      staticClass: "select-check",
                      attrs: { value: _vm.isSelected(img) },
                    }),
                    _c("w-spacer"),
                    _vm.isSelfBilling
                      ? _c("span", { staticClass: "self-billing-icon" }, [
                          _vm._v(_vm._s(_vm.$ct("self-billing"))),
                        ])
                      : _vm._e(),
                    _vm.showApprovedIcon(img)
                      ? _c("span", { staticClass: "approved-icon" }, [
                          _vm._v(_vm._s(_vm.$ct("approved"))),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "img" }, [
                  _c("div", {
                    staticClass: "img-wrap",
                    style: { backgroundImage: "url(" + img.ThumbUrl + ")" },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "img-actions",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "preview-button",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.previewFile(img)
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            staticClass: "mrs",
                            attrs: { icon: "eye" },
                          }),
                          _vm._v(_vm._s(_vm.$ct("view")) + " "),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "hover-actions doc-actions" },
                        [
                          _c("w-dropdown", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("more-actions"),
                                expression: "$ct('more-actions')",
                              },
                            ],
                            attrs: {
                              flat: "",
                              up: "",
                              right: "",
                              "trigger-class": "more-button",
                              icon: "ellipsis-h",
                              items: _vm.gridMenuItems(img),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onActionClick(img, $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "info" },
                  [
                    _c(
                      "div",
                      { staticClass: "img-name" },
                      [
                        _vm.purchase.PeppolOrder
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.purchase.PeppolOrder.Supplier.Name)
                              ),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.purchase.PeppolOrder.OrderNumber) +
                                  " "
                              ),
                            ]
                          : img.getSupplierLabel() || img.getTotalLabel()
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    img.getSupplierLabel() || img.getName()
                                  )
                              ),
                              _c("br"),
                              _c("span", { staticClass: "total" }, [
                                _vm._v(_vm._s(img.getTotalLabel())),
                              ]),
                              img.getDueDate()
                                ? _c("span", { staticClass: "total" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          img.getTotalLabel() ? " · " : ""
                                        ) +
                                        _vm._s(_vm.$ct("expires-short")) +
                                        " " +
                                        _vm._s(img.getDueDate()) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          : [_vm._v(" " + _vm._s(img.getName()) + " ")],
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "labels",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _vm.isPeppol
                          ? _c(
                              "span",
                              { staticClass: "label-chip source-chip" },
                              [
                                _c("w-fa", { attrs: { icon: "share-alt" } }),
                                _c("span", { staticClass: "label-chip-name" }, [
                                  _vm._v(_vm._s(_vm.$ct("source-peppol"))),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._l(img.Labels, function (l) {
                          return _c(
                            "span",
                            {
                              key: l.ID,
                              staticClass: "label-chip",
                              style: {
                                backgroundColor: l.Color,
                                color: _vm.textColor(l.Color),
                              },
                            },
                            [
                              _c("span", { staticClass: "label-chip-name" }, [
                                _vm._v(_vm._s(l.Name)),
                              ]),
                              _c(
                                "a",
                                {
                                  staticClass: "label-chip-close",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeLabelFromFile(img, l)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "times" } })],
                                1
                              ),
                            ]
                          )
                        }),
                        _vm.labelItems(img).length
                          ? _c(
                              "w-dropdown",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("add-label"),
                                    expression: "$ct('add-label')",
                                  },
                                ],
                                attrs: {
                                  flat: "",
                                  sm: "",
                                  "trigger-class": "add-label-chip",
                                  items: _vm.labelItems(img),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.assignLabelToFile(img, $event)
                                  },
                                },
                              },
                              [
                                _c("w-fa", {
                                  staticClass: "mrs",
                                  attrs: { icon: "tag" },
                                }),
                                _vm._v(_vm._s(_vm.$ct("label")) + " "),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("app-timeago", {
                      staticClass: "date",
                      attrs: { datetime: _vm.purchase.DateCreated },
                    }),
                  ],
                  1
                ),
              ]
            )
          }),
          _vm.setNoteForBookkeeperOpen
            ? _c("app-set-note-for-bookkeeper-modal", {
                attrs: { purchase: _vm.purchase },
                on: {
                  close: function ($event) {
                    _vm.setNoteForBookkeeperOpen = false
                  },
                },
              })
            : _vm._e(),
          _vm.labelsFile
            ? _c("app-assign-labels-modal", {
                attrs: { file: _vm.labelsFile, labels: _vm.state.labels },
                on: {
                  close: function ($event) {
                    _vm.labelsFile = null
                  },
                },
              })
            : _vm._e(),
        ],
        2
      )
    : _c(
        "tbody",
        [
          _vm._l(_vm.files, function (img, i) {
            return _c(
              "tr",
              {
                key: _vm.purchase.ID + "-" + i,
                class: { selected: _vm.isSelected(img) },
                on: {
                  mousedown: function ($event) {
                    return _vm.onMouseDown($event)
                  },
                  click: function ($event) {
                    return _vm.onClick(img, $event)
                  },
                },
              },
              [
                _c(
                  "td",
                  [
                    _c("w-checkbox", {
                      staticClass: "select-check",
                      attrs: { value: _vm.isSelected(img) },
                    }),
                  ],
                  1
                ),
                _c("td", [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.sourceTooltip,
                          expression: "sourceTooltip",
                        },
                      ],
                      staticClass: "source-badge",
                      class: _vm.sourceKind,
                    },
                    [_c("w-fa", { attrs: { icon: _vm.sourceIcon } })],
                    1
                  ),
                ]),
                _c("td", [
                  _c("div", { staticClass: "row-supplier" }, [
                    _vm._v(_vm._s(_vm.supplierName(img))),
                  ]),
                  _vm.documentRef(img)
                    ? _c("div", { staticClass: "row-secondary" }, [
                        _vm._v(_vm._s(_vm.documentRef(img))),
                      ])
                    : _vm._e(),
                ]),
                _c("td", [
                  _vm.showApprovedIcon(img)
                    ? _c("span", { staticClass: "status-chip approved" }, [
                        _c("span", { staticClass: "status-dot" }),
                        _vm._v(_vm._s(_vm.$ct("approved")) + " "),
                      ])
                    : _vm._e(),
                  _vm.isSelfBilling
                    ? _c("span", { staticClass: "self-billing-icon" }, [
                        _vm._v(_vm._s(_vm.$ct("self-billing"))),
                      ])
                    : _vm._e(),
                ]),
                _c("td", [
                  _vm._v(_vm._s(_vm.invoiceDateString(img) || _vm.dash)),
                ]),
                _c(
                  "td",
                  [
                    _vm.dueDateString(img)
                      ? [
                          _vm._v(" " + _vm._s(_vm.dueDateString(img)) + " "),
                          _vm.dueDateRelative(img)
                            ? _c("div", { staticClass: "row-secondary" }, [
                                _vm._v(_vm._s(_vm.dueDateRelative(img))),
                              ])
                            : _vm._e(),
                        ]
                      : [_vm._v(_vm._s(_vm.dash))],
                  ],
                  2
                ),
                _c("td", { staticClass: "row-amount" }, [
                  _vm._v(_vm._s(_vm.amountLabel(img) || _vm.dash)),
                ]),
                _c("td", [
                  _c(
                    "div",
                    {
                      staticClass: "labels labels-row",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _vm._l(img.Labels, function (l) {
                        return _c(
                          "span",
                          {
                            key: l.ID,
                            staticClass: "label-chip",
                            style: {
                              backgroundColor: l.Color,
                              color: _vm.textColor(l.Color),
                            },
                          },
                          [
                            _c("span", { staticClass: "label-chip-name" }, [
                              _vm._v(_vm._s(l.Name)),
                            ]),
                            _c(
                              "a",
                              {
                                staticClass: "label-chip-close",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.removeLabelFromFile(img, l)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "times" } })],
                              1
                            ),
                          ]
                        )
                      }),
                      _vm.labelItems(img).length
                        ? _c(
                            "w-dropdown",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("add-label"),
                                  expression: "$ct('add-label')",
                                },
                              ],
                              attrs: {
                                flat: "",
                                sm: "",
                                "trigger-class": "add-label-chip",
                                items: _vm.labelItems(img),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.assignLabelToFile(img, $event)
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                staticClass: "mrs",
                                attrs: { icon: "tag" },
                              }),
                              _vm._v(_vm._s(_vm.$ct("label")) + " "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _c("td", { staticClass: "row-buttons" }, [
                  _c(
                    "div",
                    {
                      staticClass: "actions doc-actions",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("w-dropdown", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("actions"),
                            expression: "$ct('actions')",
                          },
                        ],
                        attrs: {
                          flat: "",
                          right: "",
                          icon: "ellipsis-h",
                          "trigger-class": "actions-trigger",
                          items: _vm.rowMenuItems(img),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onActionClick(img, $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            )
          }),
          _vm.setNoteForBookkeeperOpen
            ? _c("app-set-note-for-bookkeeper-modal", {
                attrs: { purchase: _vm.purchase },
                on: {
                  close: function ($event) {
                    _vm.setNoteForBookkeeperOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }